import TableContainer from "@/components/_table-container";
import LoadingModal from '@/components/_modals/loading';
import CowChangeApi from '../../../api/cow-change-api';
import UtilsService from "../../../services/UtilsService";

export default {
  name: 'HeatReportModal',

  components: { TableContainer, LoadingModal },

  props: {
    generateHeatReport: Object,
    isModalOpen: Boolean,
    reload: Function
  },

  data() {
    return {
      heatReporData: [],
      heatReportMaxAlerts: 0,
      isFetching: true,
      hasData: false,
      heatHeatAiChangeDate: '2023-05-11'
    };
  },
  methods: {
    async getCowLogs(download = false) {
      if (this.generateHeatReport.fromDate === null) {
        this.generateHeatReport.fromDate = this.$moment().subtract(1, 'months').format('YYYY-MM-DDTHH:mm:ssZ');
      }
      const fromDate = new Date(this.generateHeatReport.fromDate);

      if (this.generateHeatReport.toDate === null)
        this.generateHeatReport.toDate = this.$moment().format('YYYY-MM-DDTHH:mm:ssZ');
      const toDate = new Date(this.generateHeatReport.toDate);

      const requestData = {
        fromDate: UtilsService.utcDate(fromDate),
        toDate: UtilsService.utcDate(toDate),
        cowIDs: this.generateHeatReport.cows.map(cow => cow.cow_id)
      }

      if (download) {
        const response = await CowChangeApi.cowsHeatCsvExport(requestData);
        UtilsService.downloadCsv(response.data, `heat_report_${this.fromDate}-${this.toDate}.csv`)
        this.isFetching = false;
        return;
      }
      const response = await CowChangeApi.getCowsHeat(requestData);

      this.heatReportMaxAlerts = Math.max(...response.data.map(cow => cow.alerts.length));

      this.heatReporData = response.data;

      this.fromDate = this.getFormattedTime(UtilsService.utcDate(fromDate));
      this.toDate = this.getFormattedTime(UtilsService.utcDate(toDate));
      this.isFetching = false;
    },
    getFormattedTime(date) {
      return this.$moment(date).format('YYYY-MM-DD HH:mm') + ('UTC');
    },
    close() {
      this.$emit('close');
    }
  },
  mounted() {
    this.getCowLogs();
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/heat-report/heat-report-modal.js